import type { ComponentType } from 'react';
import type { MessageDescriptor } from 'react-intl';

import { triggerMessages } from './messages';
import type { EventFilterInputProps } from './registry-types.d';
import type { WorkflowEventType } from '../types.d';
import { TagEventFilterInput } from '../components/trigger-editor/tag-event-filter-input';

export type TriggerRegistryEntry = {
  eventType: WorkflowEventType;
  labelMessage: MessageDescriptor;
  hasEventFilter: boolean;
  // Component that renders the event filter UI for this trigger type.
  // Undefined for triggers with no event filter (hasEventFilter: false).
  // Add a new component here when a new trigger type with a different filter UI lands.
  eventFilterInput?: ComponentType<EventFilterInputProps>;
};

// Tag-based triggers (OrderTagAdded, OrderTagRemoved) accept an eventFilter
// with TagId criteria; all others send eventFilter: null.
export const TriggerRegistry: TriggerRegistryEntry[] = [
  {
    eventType: 'OrderTagAdded',
    labelMessage: triggerMessages.orderTagAdded,
    hasEventFilter: true,
    eventFilterInput: TagEventFilterInput,
  },
  {
    eventType: 'OrderTagRemoved',
    labelMessage: triggerMessages.orderTagRemoved,
    hasEventFilter: true,
    eventFilterInput: TagEventFilterInput,
  },
];
